if (!customElements.get('comparison-table')) {
  class ComparisonTable extends HTMLElement {
    #handleInputChange = (ev) => {
      const elInput = ev.currentTarget;

      if (!elInput.checked) return;

      const elSelect = elInput.closest('[data-comparison-slot-select]');
      const slotIndex = elSelect?.dataset.comparisonSlotSelect;

      if (slotIndex == null) return;

      this.#updateSlot(slotIndex, elInput.value, elInput);
    };

    connectedCallback() {
      this.elStatus = this.querySelector('[data-comparison-status]');
      this.statusTemplate = this.elStatus?.dataset.statusTemplate;

      for (const elInput of this.querySelectorAll('[data-comparison-slot-select] input[type="radio"]')) {
        elInput.addEventListener('change', this.#handleInputChange);
      }
    }

    disconnectedCallback() {
      for (const elInput of this.querySelectorAll('[data-comparison-slot-select] input[type="radio"]')) {
        elInput.removeEventListener('change', this.#handleInputChange);
      }
    }

    #updateSlot(slotIndex, columnIndex, elInput) {
      const elTemplate = this.querySelector(`template[data-column-index="${columnIndex}"]`);

      if (!elTemplate) return;

      const elHeaderSource = elTemplate.content.querySelector('[data-fragment="header"] .comparison-table--product-inner');
      const elHeaderTarget = this.querySelector(`th.comparison-table--product[data-comparison-slot="${slotIndex}"]`);

      if (elHeaderSource && elHeaderTarget) {
        let elHeaderInner = elHeaderTarget.querySelector('.comparison-table--product-inner');

        if (!elHeaderInner) {
          elHeaderInner = document.createElement('div');
          elHeaderInner.className = 'comparison-table--product-inner';
          elHeaderTarget.appendChild(elHeaderInner);
        }

        elHeaderInner.innerHTML = elHeaderSource.innerHTML;
        elHeaderTarget.dataset.columnIndex = columnIndex;
        elHeaderTarget.removeAttribute('aria-hidden');
        elHeaderTarget.classList.add('overlay-link--parent');
        elHeaderTarget.classList.remove('comparison-table--product--empty');
      }

      const cellFragments = [...elTemplate.content.querySelectorAll('[data-fragment="cell"]')];
      const elRows = this.querySelectorAll('tbody tr.comparison-table--row');

      for (const [rowIndex, elRow] of [...elRows].entries()) {
        const elCellSource = cellFragments[rowIndex];
        const elCellTarget = elRow.querySelector(`td[data-comparison-slot="${slotIndex}"]`);

        if (!elCellSource || !elCellTarget) continue;

        elCellTarget.innerHTML = elCellSource.innerHTML;
        elCellTarget.dataset.columnIndex = columnIndex;
        elCellTarget.removeAttribute('aria-hidden');
        elCellTarget.classList.remove('comparison-table--cell--empty');
      }

      window.initLazyLoad?.();
      this.#announce(slotIndex, elInput);
    }

    #announce(slotIndex, elInput) {
      if (!this.elStatus || !this.statusTemplate) return;

      const productTitle = elInput.labels?.[0]?.textContent?.trim();
      const columnNumber = Number(slotIndex) + 1;

      if (!productTitle) return;

      this.elStatus.textContent = this.statusTemplate
        .replace('__NUMBER__', String(columnNumber))
        .replace('__PRODUCT__', productTitle);
    }
  }

  customElements.define('comparison-table', ComparisonTable);
}
